<script>
    import Title from "../Components/Title.svelte";
    import Button from "../Components/Button.svelte";
    import {navigateTo} from "svelte-router-spa";
    import {accessToken, refreshToken, userData} from "../Core/LocalStorage";

    async function signOut() {
        userData.set(null);
        accessToken.set(null);
        refreshToken.set(null);
        navigateTo('/');
    }

    let firstName = $userData.firstName,
        lastName = $userData.lastName;
</script>

<div class="max-w-6xl relative h-full mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex flex-col h-full">
        <div>
            <Title textColor="text-hand-pink-500">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
                </svg>
                <span>
                    Settings
                </span>
            </Title>
        </div>
        <div class="flex-1 flex flex-col space-y-4">
            <h2 class="text-xl">Hi, {firstName} {lastName}.</h2>
            <p>You're signed in to HAND for Workers. There's not much to see here but there might be in the future.</p>
        </div>
        <div class="flex flex-col items-center justify-center py-4 space-y-2">
            <Button mode="danger" on:click={signOut}>Sign out of HAND</Button>
            <div class="text-xs text-gray-400">
                Build API220203-9
            </div>
        </div>
    </div>
</div>